<template>
	<span class="conductor-job-status" v-bind:class="derived">
		{{ derived }}<template v-if="derived == 'waiting'"> {{ relative }}</template>
	</span>
</template>

<script>
import moment from 'moment'

export default {
  props: [
    'job',
    'now'
  ],
  computed: {
    derived () {
      if (this.job.status == 'pending') {
        return this.job.run_after && moment.utc(this.job.run_after).isAfter(moment.utc(this.now)) ? 'waiting' : 'due'
      }

      if (this.job.status == 'running') {
        return this.job.claimed_until && moment.utc(this.job.claimed_until).isAfter(moment.utc(this.now)) ? 'running' : 'stalled'
      }

      return this.job.status
    },
    relative () {
      return moment.utc(this.job.run_after).from(moment.utc(this.now))
    }
  }
}
</script>

<style lang="less" scoped>
.conductor-job-status {
	display: inline-block;
	padding: 2px 8px;
	border-radius: 3px;
	font-size: 12px;
	white-space: nowrap;
	background: #ddd;
	color: #323232;
	&.running {
		background: #2f6fd0;
		color: #fff;
	}
	&.done {
		background: #4daa00;
		color: #fff;
	}
	&.failed {
		background: #fe0006;
		color: #fff;
	}
	&.stalled {
		background: #e7b700;
		color: #323232;
	}
}
</style>
